import { render } from "./Recommendation-comparison.vue?vue&type=template&id=1eedc001&scoped=true"
import script from "./Recommendation-comparison.vue?vue&type=script&lang=js"
export * from "./Recommendation-comparison.vue?vue&type=script&lang=js"

import "./Recommendation-comparison.vue?vue&type=style&index=0&id=1eedc001&lang=css"
import "./Recommendation-comparison.vue?vue&type=style&index=1&id=1eedc001&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eedc001"]])

export default __exports__